import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormAccessor {
  isValid(field: AbstractControl | null): boolean {
    return field ? field.valid : false;
  }

  isTouched(field: AbstractControl | null): boolean {
    return field ? field.touched : false;
  }

  isPristine(field: AbstractControl | null): boolean {
    return field ? field.pristine : false;
  }

  isDirty(field: AbstractControl | null): boolean {
    return field ? field.dirty : false;
  }

  hasValidator(field: AbstractControl | null): boolean {
    return field ? !!field.validator : false;
  }

  value(field: AbstractControl | null): string {
    return field ? field.value : '';
  }

  isEmpty(field: AbstractControl | null): boolean {
    if (field === null) {
      return false;
    } else {
      return !field.value && (field.value !== 0);
    }
  }

  getField(formGroup: FormGroup, fieldName: string): AbstractControl | null {
    return formGroup.get(fieldName);
  }

  setErrors(
    control: AbstractControl | null,
    errors: {[key: string]: any}): void {
      if (control) {
        control.setErrors(errors)
      }
    }
}
